import React, { useRef } from "react";
import { COLORS } from "theme";
import TestimonialCards from "Pages/Landing/components/Testimonials/components/TestimonialCards";
import Box from "ReusableComponents/Box";
import { Grid } from "@mui/material";
import ButtonArrowWhite from "assets/rightpathWhite.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.css";

const Carousel = ({ small, testimonials }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      spacing={2}
      style={{ border: "0px" }}
    >
      <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <Swiper
          spaceBetween={0}
          height={"auto"}
          slidesPerView={small ? 1 : 3}
          onSlideChange={() => console.log("slide change")}
          onSwiper={(swiper) => console.log(swiper)}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
          autoplay={{
            delay: 4500,
            disableOnInteraction: false,
          }}
        >
          {testimonials?.map((item, id) => (
            <SwiperSlide
              key={id}
              style={{
                backgroundColor: COLORS.lightBlack,
                marginLeft: small ? "3px" : "0px",
              }}
            >
              <Box
                paddingLeft="0"
                padding="30px 0"
                position="relative"
                zIndex="2"
                bgc={COLORS.lightBlack}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <TestimonialCards
                  name={item?.attributes?.user}
                  designation={item?.attributes?.designation}
                  Image={item?.attributes?.image?.data?.attributes?.url}
                  alt={
                    item?.attributes?.image?.data?.attributes?.alternativeText
                  }
                  description={item?.attributes?.testimonial}
                  border={COLORS.primary}
                  small={small}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid>
      {!small && (
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "right", // Center the buttons horizontally
            marginTop: "20px",
            marginRight: "20px",
          }}
        >
          <Box display="flex" alignItems="right" justifyContent="right">
            <button
              ref={prevRef}
              style={{
                backgroundColor: "transparent",
                border: "3px solid white",
                cursor: "pointer",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "30px",
              }}
            >
              <img
                src={ButtonArrowWhite}
                alt="Previous"
                style={{
                  transform: "rotate(180deg)",
                  width: "30px",
                  padding: "8px",
                }}
              />
            </button>
            <button
              ref={nextRef}
              style={{
                backgroundColor: "transparent",
                border: "3px solid white",
                cursor: "pointer",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={ButtonArrowWhite}
                alt="Next"
                style={{ width: "30px", padding: "8px" }}
              />
            </button>
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default Carousel;
